import { Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, debounceTime } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NavigationService {
    private _isNavbarInverseColors = new BehaviorSubject<boolean>(true);

    // debounceTime smooths rapid scroll toggles; the initialValue paints the
    // default synchronously so the prerendered shell and first frame aren't
    // white before the debounced stream emits.
    readonly isNavbarInverseColors: Signal<boolean> = toSignal(
        this._isNavbarInverseColors.pipe(debounceTime(50)),
        { initialValue: true }
    );

    setNavbarInverseColors(value: boolean) {
        this._isNavbarInverseColors.next(value);
    }
}
